import { Module } from '../Module';
import { WindowLocationService } from '../../commonInfra/services/WindowLocationService';
import {SimpleDeferred} from '../../../src/app/utils/SimpleDeferred';

// Launches desktop applications using custom URI schemes (e.g. "tableau:" and "tableau-online-sync:")
export namespace DesktopApplicationLaunchService {

  // Open Tableau Desktop with a protocol handler
  export function launchTableauDesktop(): Promise<any> {
    return launchDesktopApplication('tableau:', true);
  }

  // Open Online Sync Client with a protocol handler.
  // Note that this application launches in the background and does not take the focus,
  // so we have limited ability to know if this failed to launch anything.
  export function launchSyncClientAndAssignToDatasource(siteUrlName: string,
                                               datasourceUrlName: string): Promise<any> {
    const uri = 'tableau-online-sync:///' + (siteUrlName || 'default') +
      '/claimScheduleForDatasource/' + datasourceUrlName;

    return launchDesktopApplication(uri, false);
  }

  function launchDesktopApplication(uri: string, onblurFailureDetection: boolean): Promise<any> {
    // How long we wait to loose focus before declaring failure.
    // The window will lose focus instantly if the browser shows a security confirmation dialog.
    // Otherwise, the window will loose focus when the desktop app we are launching takes focus away from the browser.
    const LaunchTimeoutMillis = 4000;

    const win = window;
    const hiddenIFrame = win.document.createElement('iframe');
    win.document.body.appendChild(hiddenIFrame);

    const blurDeferred = new SimpleDeferred<any>();

    if (onblurFailureDetection) {
      $(win).one('blur', () => {
        // Focus was blurred! Assume success since something opened to take focus away.
        blurDeferred.resolve(true); // report success
      });

      // Fail after not getting blur event for a while
      window.setTimeout(
        () => blurDeferred.reject('timeout'), // report failure
        LaunchTimeoutMillis
      );
    }

    try {
      WindowLocationService.navigateIFrameTo(hiddenIFrame, uri);
    } catch (e) {
      // Fail fast.
      // We were lucky enough to get an exception for the failure!
      // (Currently only Firefox will throw an exception here when the protocol is not recognized)
      return Promise.reject();
    }

    if (!onblurFailureDetection) {
      // report success right away
      return Promise.resolve();
    }

    // Wait for focus to blur or not...
    return blurDeferred.promise;
  }

}

export type DesktopApplicationLaunchService = typeof DesktopApplicationLaunchService;